<ng-container *transloco="let convert;">
  <div class="advanced_search_make">
    <div class="advanced_search_make__arrow"></div>
    <div class="form-group advanced_search_make--search">
      <label for="advanced_search_make">{{convert('sellModule.manageInventory.advancedSearch.advancedSearchMake.labelSearch')}}</label>
      <div class="control-wrapper">
        <input name="search" id="advanced_search_make" class="form-control" (input)="onInput($event)" maxlength="30" />
      </div>
    </div>

    <!-- <ng-container *ngIf="localSelected.length !== 0 && (makeOptions$ | async)?.divider; else dropDown"> -->
    @if (localSelecedMake && localSelecedMake.length !== 0) {
      <div class="form-group">
        <div class="control-wrapper">
          @for (make of localSelecedMake; track make) {
            <div
              class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
              >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="make"
                [checked]="checked(make)"
                (change)="selectOption(make)"
                />
              <label class="custom-control-label" [for]="make">{{ make }}</label>
            </div>
          }
        </div>
      </div>
      <div class="advanced_search_make--divider"></div>
      <div class="form-group">
        <div class="control-wrapper">
          @for (make of filteredMakeOPtions; track make) {
            <div
              class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
              [ngClass]="{ 'd-none': localSelecedMake.includes(make) }"
              >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="make"
                [checked]="checked(make)"
                (change)="selectOption(make)"
                />
              <label class="custom-control-label" [for]="make">{{ make }}</label>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="form-group">
        <div class="control-wrapper">
          @for (make of filteredMakeOPtions; track make) {
            <div
              class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
              >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="make"
                [checked]="checked(make)"
                (change)="selectOption(make)"
                />
              <label class="custom-control-label" [for]="make">{{ make }}</label>
            </div>
          }
        </div>
      </div>
    }

    <ng-template #dropDown>
      <div class="form-group">
        <div class="control-wrapper">
          @for (make of filteredMakeOPtions; track make) {
            <div
              class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
              >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="make"
                [checked]="checked(make)"
                (change)="selectOption(make)"
                />
              <label class="custom-control-label" [for]="make">{{ make }}</label>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <div class="advanced_search_make--action_btn">
      <button
        class="btn btn-secondary advanced_search_make--action_btn__close"
        [attr.aria-label]="convert('common.btnClose')"
        type="button"
        (click)="close()"
        >
        {{convert('common.btnClose')}}
      </button>
    </div>
  </div>
</ng-container>

<!-- <div
class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
*ngFor="let make of (makeOptions$ | async).filteredMakeOptions"
> -->
